import { render } from "./formp2hsarana.vue?vue&type=template&id=4a47d346"
import script from "./formp2hsarana.vue?vue&type=script&lang=js"
export * from "./formp2hsarana.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__